import {Col, Row} from "antd";
import styles from "./index.module.scss"

const Advantage = () => {
    return (
        <>
            <div className={styles['section-title']}>
                <div className={styles.chs}>我们的优势</div>
            </div>
            <Row gutter={[16, 16]}>
                <Col span={8} className={styles.col}>
                    <div className={`${styles['advantage-item']} ${styles.firstBackground}`}>
                        <h2>经验丰富</h2>
                        <p>多年行业经验，为您提供更稳定、更可靠的解决方案</p>
                    </div>
                </Col>
                <Col span={8} className={styles.col}>
                    <div className={`${styles['advantage-item']} ${styles.secondBackground}`}>
                        <h2>专业团队</h2>
                        <p>汇聚行业精英，专业团队为您保驾护航</p>
                    </div>
                </Col>
                <Col span={8} className={styles.col}>
                    <div className={`${styles['advantage-item']} ${styles.thirdBackground}`}>
                        <h2>品质卓越</h2>
                        <p>严格把控品质，确保每一项服务都达到最高标准</p>
                    </div>
                </Col>
                <Col span={8} className={styles.col}>
                    <div className={`${styles['advantage-item']} ${styles.fourthBackground}`}>
                        <h2>客户至上</h2>
                        <p>以客户为中心，用心倾听，满足您的每一个需求</p>
                    </div>
                </Col>
                <Col span={8} className={styles.col}>
                    <div className={`${styles['advantage-item']} ${styles.fifthBackground}`}>
                        <h2>定制化服务</h2>
                        <p>量身定制，满足您的个性化需求</p>
                    </div>
                </Col>
                <Col span={8} className={styles.col}>
                    <div className={`${styles['advantage-item']} ${styles.sixthBackground}`}>
                        <h2>服务周到</h2>
                        <p>全方位服务，从咨询到售后，全程陪伴，让您无忧</p>
                    </div>
                </Col>
            </Row>
        </>
    )
}

export default Advantage;